import type { PropsWithChildren, FC } from 'react';
import { useContext } from 'react';

import UserContext from 'app/common/UserContext';
import NotFound from 'app/common/NotFound';
import type { Feature } from 'app/config/features.config';
import { hasAccess, hasAccessToFeature } from 'app/utils/permissions';

interface Props {
  access?: UserType[];
  feature?: Feature;
  condition?: boolean;
}

// Logic from: https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
const WithAccess: FC<PropsWithChildren<Props>> = ({
  children,
  access,
  feature,
  condition = true
}) => {
  const { userType, status: authStatus } = useContext(UserContext);
  const authenticating = authStatus === 'LOADING';
  const hasAccessValue =
    (access && hasAccess(access, userType)) ||
    (feature && hasAccessToFeature(feature, userType) && condition);

  if (hasAccessValue) {
    return <>{children}</>;
  }
  if (authenticating) {
    return null;
  }

  // if user hasn't access, we show the not found page
  return <NotFound />;
};

WithAccess.displayName = 'WithAccess';

export default WithAccess;
